import AutoComplete from "@tarekraafat/autocomplete.js/src/autocomplete.js";
import { dbfetch } from "./dbfetch";
import { registerComponent } from "./component";
import { initPopupContainer, initPopup } from "./_menu";
import { createElement, onEvent, uniqueId } from "./_dom";

const maxResults = 20;

function htmlEncode(s) {
	const r = { "<": "&lt;", ">": "&gt;", "&": "&amp;" };
	return s.replace(/<>&/g, m => r[m]);
}

const regexEncode = (search) => search.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');

function createAutocomplete(field) {
	const url = field.dataset.autocompleteUrl;
	const fieldId = uniqueId(field);
	const listId = `autoComplete_list_${fieldId}`;
	const hightlightClass = "v3-typeinpicker__mark";
	const typeInInput = field;
	const valueControl = document.querySelector(typeInInput.dataset.autocompleteValue);
	/*const autocompleteDropdown = */ new AutoComplete({
		selector: `#${fieldId}`,
		wrapper: false,
		threshold: 2,
		debounce: 300,
		data: {
			src: async (query) => {
				try {
					const fetchUrl = new URL(url);
					const qs = fetchUrl.searchParams;
					qs.set("search", query);
					qs.set("top", maxResults);
					qs.set("js", Math.random());
					const source = await dbfetch(fetchUrl);
					if (!source.ok)
						throw new Error(source.statusText);
					return await source.json();
				} catch (error) {
					return error;
				}
			},
			keys: ['label']
		},
		/**
		 * @param {String} query
		 * @param {String} record
		 * @returns {String?}
		 */
		searchEngine: function (query, record) {
			if (record) {
				const qwords = query.split(' ');
				qwords.forEach((s, i) => qwords[i] = s.trim());
				const parts = [0, record.length];
				for (let i = 0; i < qwords.length; i++) {
					const qword = qwords[i];
					if (qword) {
						const rg = new RegExp("\\b" + regexEncode(qword), "gi");
						for (const match of record.matchAll(rg))
							parts.push(match.index, match.index + match[0].length);
					}
				}
				if (parts.length > 2) {
					parts.sort((a, b) => a - b);
					const result = [];
					for (let i = 0; i < parts.length; i += 2) {
						const t = parts[i], mb = parts[i + 1], me = parts[i + 2];
						if (t < mb)
							result.push(htmlEncode(record.substring(t, mb)));
						result.push(`<mark class="${hightlightClass}">${htmlEncode(record.substring(mb, me))}</mark>`);

					}
					record = result.join("");
				}
			}
			return record;
		},
		resultsList: {
			id: listId,
			tag: "ul",
			class: "v3-typeinpicker__menu v3-menu v3-menu-scrollable v3-popup",
			destination: initPopupContainer,
			position: "beforeend",
			maxResults
		},
		resultItem: {
			element: (el) => {
				var subitems = [...el.childNodes];
				el.setAttribute("role", "none");
				el.replaceChildren(createElement("span", { class: "v3-menu__item", role: "option" }, ...subitems));
			},
			tag: "li",
			class: "v3-menu__cell",
			selected: "active",
			highlight: hightlightClass
		},
		events: {
			input: {
				selection: (event) => {
					const { value, label } = event.detail.selection.value;
					typeInInput.value = label;
					if (valueControl.value != value) {
						valueControl.value = value;
						valueControl.dispatchEvent(new Event("change", { bubbles: true }));
					}
				}
			}
		}
	});
	field.addEventListener("open", () => {
		const list = document.getElementById(listId);
		initPopup(field, list);
	});
	field.addEventListener("close", () => {
		const list = document.getElementById(listId);
		list.popperCleanup?.();
	});
	field.addEventListener("input", () => {
		if (valueControl.value != "") {
			valueControl.value = "";
			valueControl.dispatchEvent(new Event("change", { bubbles: true }));
		}
	});
	field.addEventListener("navigate", () => {
		const list = document.getElementById(listId);
		list.querySelectorAll(".v3-menu__item--active").forEach(item => item.classList.remove("v3-menu__item--active"));
		list.querySelector(".v3-menu__cell.active > .v3-menu__item")?.classList.add("v3-menu__item--active");
	});
	field.addEventListener("change", () => {
		if (field.dataset.autocompleteText) {
			const textControl = document.querySelector(field.dataset.autocompleteText);
			if (textControl)
				textControl.value = field.value;
		}
	});
}

const autocomplete = registerComponent(createAutocomplete);

function init(context, selector = "input[data-autocomplete-value]") {
	onEvent(context, selector, "focusin", (_event, input) => autocomplete(input));
	// return autocomplete(selector, context);
}

export { init/*, autocomplete*/ };